import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Modal, Spinner } from "react-bootstrap";
import { PayloadProps } from "../../core/schema";
import { getLocalStorage } from "../../core/localStorageService";
import apiEndpoint from "../../core/apiend_point";
import { triggerApi } from "../../services";
import BackSecion from "../common/header";
import Gallery from "./gallery";
import ReactPlayer from "react-player/lazy";

export type Alubum = {
  albums: [];
  album_images: [];
  video_category_data: any;
  album_videos: [];
};

/**
 * Renders Component.
 * @return {StudentGallery} renders Component.
 */
export default function StudentGallery() {
  const [data, setData] = useState<Alubum>({
    albums: [],
    album_images: [],
    video_category_data: [],
    album_videos: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showDocument, setShowDocument] = useState(false);
  const [images, setImages] = useState<any>([]);
  const [vedios, setVedios] = useState<any>([]);
  const [selectedTab, setSelectedTab] = useState(0);
  useEffect(() => {
    getGallary();
  }, []);

  const getGallary = () => {
    setIsLoading(true);
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
      },
      method: "POST",
      apiUrl: apiEndpoint.mediaGallery,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.data && res.data.albums) {
          setData({
            albums: res.data.albums,
            album_images: res.data.album_images,
            video_category_data: res.data.video_category_data
              ? Object.values(res.data.video_category_data)
              : [],
            album_videos: res.data.album_videos ? res.data.album_videos : [],
          });
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  function onGallerClick(index: number) {
    setImages(data.album_images[index]);
    setShowDocument(true);
  }
  function onGallerVedioClick(index: number) {
    setVedios(data.album_videos[index])
    setShowDocument(true);
  }

  return (
    <>
      <div className="cmmn">
        <Container className="container ">
          <BackSecion name="Gallery" navigate_action="/home" />

          <Row className="mt-4 mx-auto mb-5">
            <Col
              xs={6}
              className="text-center blue_clr f-14 fw-bold"
              onClick={() => setSelectedTab(0)}
            >
              <span role="button" className="fw-bolder link_style">
                Photos
              </span>
            </Col>
            <Col xs={6} className="text-center inactive_clr f-14">
              <span
                role="button"
                className="text-decoration-none status_clr link_style fw-bold"
                onClick={() => setSelectedTab(1)}
              >
                Videos
              </span>
            </Col>
          </Row>
          {isLoading && (
            <div className="loader">
              <Spinner animation="border" variant="primary" />
            </div>
          )}

          <div className="row mt-4 m-auto justify-content-around">
            {!isLoading &&
              selectedTab === 0 &&
              data.albums &&
              data.albums.length > 0 &&
              data.albums.map((item: any, i: number) => {
                return (
                  <div
                    className="col-5 col-sm-4 mb-2 d-flex flex-column align-items-center"
                    key={`album-${i}`}
                    onClick={() => onGallerClick(item.id)}
                  >
                    <div className="mb-2">
                      <img
                        src={item.cover_img_url}
                        alt=""
                        width="156px"
                        height="156px"
                      />
                    </div>
                    <p className="f-14"> {item.name} </p>
                  </div>
                );
              })}

            {!isLoading &&
              selectedTab === 1 &&
              data.video_category_data.length > 0 &&
              data.video_category_data.map((item: any, i: number) => {
                return (
                  <div
                    className="col-5 col-sm-4 mb-2 d-flex flex-column align-items-center"
                    key={`vidio-${i}`}
                    onClick={() => onGallerVedioClick(item[0].id)}
                  >
                    <div className="mb-2">
                      <img
                        src={item[0].cover_img_url}
                        alt=""
                        width="156px"
                        height="156px"
                      />
                    </div>
                    <p className="f-14"> {item[0].category_name} </p>
                  </div>
                );
              })}
          </div>

          {showDocument && (
            <Modal
              show={showDocument}
              fullscreen={true}
              onHide={() => setShowDocument(false)}
            >
              <Modal.Body>
                <div onClick={() => setShowDocument(false)}>
                  <BackSecion name="Gallery" />
                </div>
                <Row className="center-content">
                  {selectedTab === 0 && <Gallery images={images} />}
                  {!isLoading &&
                    selectedTab === 1 &&
                    vedios &&
                    vedios.length > 0 &&
                    vedios.map((item: any, i: number) => {
                      return (
                        <div className="mb-2" key={`vedio_${i}`}>
                        <ReactPlayer
                          width={350}
                          height={200}
                          url={item.video_url}
                          controls={true}
                          volume={1}
                          muted={false}
                        />
                        </div>
                      );
                    })}
                </Row>
              </Modal.Body>
            </Modal>
          )}
        </Container>
      </div>
    </>
  );
}
